'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import type { CityCode } from '@loci/city-editions';

import { cityReturnUrl, type CrossHostStageOptions } from '@/lib/cross-host-urls';

/**
 * Absolute URL of the current marketing-city page. Thread through
 * `crossHostLogin` / `crossHostSignup` as `next` so cross-host auth returns
 * the visitor to the page they were reading instead of the app feed
 * (WEB-898).
 */
export function useCityReturnUrl(cityCode: CityCode, stage?: CrossHostStageOptions): string {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  return cityReturnUrl(cityCode, pathname, searchParams.toString(), stage);
}
